import { LocalizedPaths } from "types/gatsby";

function legacyUrl(path: undefined | null): undefined;
function legacyUrl(path: string): string;
function legacyUrl(path: string | undefined | null): string | undefined {
  if (!path) return undefined;
  if (path == "/") return path;
  if (path.endsWith(".html")) return path;

  return `${path}.html`;
}

function legacyUrls(paths: LocalizedPaths): LocalizedPaths {
  return Object.keys(paths).reduce<LocalizedPaths>((links, languageCode) => {
    links[languageCode] = legacyUrl(paths[languageCode]);
    return links;
  }, {});
}

export { legacyUrl, legacyUrls };
